import { Stack } from '@mui/material';

import { AppTypography } from '../app-typography';
import { getCurrentTimezoneDisplay } from 'src/utils/dateTime';
import useDateFilter from 'src/hooks/useDateFilter';

//
//

export const TimezoneDescriptor = () => {
  const { selectedTimezone } = useDateFilter();

  return (
    <Stack alignItems="flex-end">
      <AppTypography variant="body2" color="textSecondary">
        {getCurrentTimezoneDisplay(selectedTimezone)}
      </AppTypography>
    </Stack>
  );
};
